import React, {Component} from "react"
import Layout from "../../../components/Layout"
import leng from "../../../data"

import "./index.scss"

import {
    DataTableSkeleton,
    Tabs, Tab,
    DataTable,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    TableCell, InlineNotification
} from "carbon-components-react";
import {
    mdata_action_valor_nok,
    mdata_action_valor,
    mdata_action_quantidade_nok,
    mdata_action_quantidade,
    mdata_collections
} from "../../../store/actions/masterData";
import {connect} from "react-redux";
import moment from "moment";

const headerData = [
    {key: "sku", header: 'SKU'},
    {key: "material_description", header: 'Material Description'},
    {key: "marca", header: 'Brand'},
    {key: "category_sku", header: 'Category'},
    {key: "categoria_principal_sku", header: 'Major Category'},
    {key: "sub_categoria_sku", header: 'Sub Category '},
    {key: "hero", header: 'HERO'},
    {key: "abcd", header: 'ABCD'},
    {key: "plc_local", header: 'PLC Local'},
    {key: "plc_global", header: 'PLC Global'},
    {key: "data_validade_sku", header: 'Global Forecast End Date'},
    {key: "urlPath", header: 'Path'},
];
const headerData2 = [
    {key: "sku", header: 'Sku'},
    {key: "_lineNumber", header: 'Line File'},
    {key: "urlPath", header: 'Path'},
    {key: "timeStamp", header: 'Creation Date'},
    {key: "Error", header: 'Message'},
];
const headerData3 = [
    {key: "channel", header: 'Canal'},
    {key: "marca", header: 'Marca'},
    {key: "yearMonthDay", header: 'Version'},
    {key: "urlPath", header: 'Path'},
];

class MasterData extends Component {
    state = {activeTab: 0, activeTabHead: 2};

    async componentDidMount() {
        await this.props.fetchData();
    }

    handleClick = (e, tab) => {
        e.preventDefault();
        console.log(tab);
        this.setState({
            activeTab: tab
        });

        if (tab === 0)
            this.props.fetchData();
        if (tab === 1)
            this.props.quantidadeNOK();
        if (tab === 2)
            this.props.valor();
        if (tab === 3)
            this.props.valorNOK();
    };

    render() {
        let {data, isLoading} = this.props;

        let rowData = data;
        rowData =
            data?.length > 0
                ? data.map(execution => {
                    return {
                        ...execution,
                        id: execution._id,
                        creationDate: moment(execution.creationDate).format(" DD MMM YY hh:mm:ss"),
                    };
                })
                : [];
        if (rowData?.length > 0) rowData.sort((a, b) => b.sortDate - a.sortDate);
        return (
            <Layout>
                <div className="section">
                    <div className="section-heading">
                        <br/>
                        <p>Dataset / {leng.sideBar.repositorio.title}</p>
                        <h1>{leng.sideBar.repositorio.links[1]}</h1>
                        <br/>
                    </div>
                    <div>
                        <Tabs className="padding-tab-head" light={"false"} scrollIntoView={false} type='container'
                              class='space-title'
                              selected={this.state.activeTabHead}>
                            <Tab
                                className="head-dark"
                                light={"false"}
                                id="produto-head"
                                label="Product"
                                key={0}
                                onClick={e => {
                                    this.props.history.push('/repo/master-data');
                                }}
                            >
                            </Tab>
                            <Tab
                                className="head-dark"
                                light={"false"}
                                id="canal-head"
                                key={1}
                                label="Channel" onClick={e => {
                                this.props.history.push('/repo/master-data/canal');
                            }}>
                            </Tab>
                            <Tab
                                className="head-dark"
                                light={"false"}
                                id="planejamento-head"
                                key={2}
                                label="Planning" onClick={e => {
                                this.handleClick(e, 0)
                            }}>
                                <div className="section-light">
                                    <div className="section-light-heading-p0">
                                        <div className="file-upload-container">
                                            <div className="tabs-story-wrapper--light">

                                                <Tabs scrollIntoView={false} selected={this.state.activeTab}>

                                                    <Tab id="quantidade" key={0} label="Quantity" name="Quantidade"
                                                         onClick={e => {
                                                             this.handleClick(e, 0)
                                                         }}
                                                    >
                                                        <div className="content-tab-planejamento">
                                                            {!isLoading && rowData.length == 0 ? (
                                                                <div>
                                                                    <InlineNotification
                                                                        lowContrast={true}
                                                                        kind="info"
                                                                        iconDescription="Info"
                                                                        subtitle={<span>No data found</span>}
                                                                        title=""
                                                                    />
                                                                </div>) :("")}
                                                            {isLoading ? (
                                                                <div className="bx--col-padding  p-2-rem">
                                                                    <DataTableSkeleton/>
                                                                </div>
                                                            ) : (
                                                                <DataTable
                                                                    rows={rowData}
                                                                    headers={headerData}>
                                                                    {({
                                                                          rows,
                                                                          headers,
                                                                          getHeaderProps,
                                                                          getRowProps,
                                                                          getTableProps
                                                                      }) => (
                                                                        <TableContainer title="Valid Data">
                                                                            <Table {...getTableProps()}>
                                                                                <TableHead>
                                                                                    <TableRow>
                                                                                        {headers.map(header => (
                                                                                            <TableHeader {...getHeaderProps({header})}>
                                                                                                {header.header}
                                                                                            </TableHeader>
                                                                                        ))}
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {rows.map((row) => (
                                                                                        <TableRow
                                                                                            className="upload-row"
                                                                                            key={row.id}
                                                                                            {...getRowProps({row})}
                                                                                        >
                                                                                            {row.cells.map((cell) => (
                                                                                                <TableCell
                                                                                                    key={cell.id}>
                                                                                                    {cell.value}
                                                                                                </TableCell>
                                                                                            ))}
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    )}
                                                                </DataTable>
                                                            )}
                                                        </div>
                                                    </Tab>

                                                    <Tab id="quantidadeNok" key={1} label="Quantity NOK"
                                                         name="quantidadeNok"
                                                         onClick={e => {
                                                             this.handleClick(e, 1)
                                                         }}
                                                    >
                                                        <div className="content-tab-planejamento">
                                                            {!isLoading && rowData.length == 0 ? (
                                                                <div>
                                                                    <InlineNotification
                                                                        lowContrast={true}
                                                                        kind="info"
                                                                        iconDescription="Info"
                                                                        subtitle={<span>No data found</span>}
                                                                        title=""
                                                                    />
                                                                </div>) :("")}
                                                            {isLoading ? (
                                                                <div className="bx--col-padding  p-2-rem">
                                                                    <DataTableSkeleton/>
                                                                </div>
                                                            ) : (
                                                                <DataTable
                                                                    rows={rowData}
                                                                    headers={headerData2}>
                                                                    {({
                                                                          rows,
                                                                          headers,
                                                                          getHeaderProps,
                                                                          getRowProps,
                                                                          getTableProps
                                                                      }) => (
                                                                        <TableContainer title="Discarded Data">
                                                                            <Table {...getTableProps()}>
                                                                                <TableHead>
                                                                                    <TableRow>
                                                                                        {headers.map(header => (
                                                                                            <TableHeader {...getHeaderProps({header})}>
                                                                                                {header.header}
                                                                                            </TableHeader>
                                                                                        ))}
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {rows.map((row) => (
                                                                                        <TableRow
                                                                                            className="upload-row"
                                                                                            key={row.id}
                                                                                            {...getRowProps({row})}
                                                                                        >
                                                                                            {row.cells.map((cell) => (
                                                                                                <TableCell
                                                                                                    key={cell.id}>
                                                                                                    {cell.value}
                                                                                                </TableCell>
                                                                                            ))}
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    )}
                                                                </DataTable>
                                                            )}
                                                        </div>
                                                    </Tab>

                                                    <Tab id="valor" key={2} label="Spend" onClick={e => {
                                                        this.handleClick(e, 2)
                                                    }}>
                                                        <div className="content-tab-planejamento">
                                                            {!isLoading && rowData.length == 0 ? (
                                                                <div>
                                                                    <InlineNotification
                                                                        lowContrast={true}
                                                                        kind="info"
                                                                        iconDescription="Info"
                                                                        subtitle={<span>No data found</span>}
                                                                        title=""
                                                                    />
                                                                </div>) :("")}
                                                            {isLoading ? (
                                                                <div className="bx--col-padding  p-2-rem">
                                                                    <DataTableSkeleton/>
                                                                </div>
                                                            ) : (
                                                                <DataTable
                                                                    rows={rowData}
                                                                    headers={headerData3}>
                                                                    {({
                                                                          rows,
                                                                          headers,
                                                                          getHeaderProps,
                                                                          getRowProps,
                                                                          getTableProps
                                                                      }) => (
                                                                        <TableContainer title="Valid Data">
                                                                            <Table {...getTableProps()}>
                                                                                <TableHead>
                                                                                    <TableRow>
                                                                                        {headers.map(header => (
                                                                                            <TableHeader {...getHeaderProps({header})}>
                                                                                                {header.header}
                                                                                            </TableHeader>
                                                                                        ))}
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {rows.map((row) => (
                                                                                        <TableRow
                                                                                            className="upload-row"
                                                                                            key={row.id}
                                                                                            {...getRowProps({row})}
                                                                                        >
                                                                                            {row.cells.map((cell) => (
                                                                                                <TableCell
                                                                                                    key={cell.id}>
                                                                                                    {cell.value}
                                                                                                </TableCell>
                                                                                            ))}
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    )}
                                                                </DataTable>
                                                            )}
                                                        </div>
                                                    </Tab>

                                                    <Tab id="valorNok" key={3} label="Spend NOK" onClick={e => {
                                                        this.handleClick(e, 3)
                                                    }}>
                                                        <div className="content-tab-planejamento">
                                                            {!isLoading && rowData.length == 0 ? (
                                                                <div>
                                                                    <InlineNotification
                                                                        lowContrast={true}
                                                                        kind="info"
                                                                        iconDescription="Info"
                                                                        subtitle={<span>No data found</span>}
                                                                        title=""
                                                                    />
                                                                </div>) :("")}
                                                            {isLoading ? (
                                                                <div className="bx--col-padding  p-2-rem">
                                                                    <DataTableSkeleton/>
                                                                </div>
                                                            ) : (
                                                                <DataTable
                                                                    rows={rowData}
                                                                    headers={headerData2}>
                                                                    {({
                                                                          rows,
                                                                          headers,
                                                                          getHeaderProps,
                                                                          getRowProps,
                                                                          getTableProps
                                                                      }) => (
                                                                        <TableContainer title="Discarded Data">
                                                                            <Table {...getTableProps()}>
                                                                                <TableHead>
                                                                                    <TableRow>
                                                                                        {headers.map(header => (
                                                                                            <TableHeader {...getHeaderProps({header})}>
                                                                                                {header.header}
                                                                                            </TableHeader>
                                                                                        ))}
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {rows.map((row) => (
                                                                                        <TableRow
                                                                                            className="upload-row"
                                                                                            key={row.id}
                                                                                            {...getRowProps({row})}
                                                                                        >
                                                                                            {row.cells.map((cell) => (
                                                                                                <TableCell
                                                                                                    key={cell.id}>
                                                                                                    {cell.value}
                                                                                                </TableCell>
                                                                                            ))}
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    )}
                                                                </DataTable>
                                                            )}
                                                        </div>
                                                    </Tab>

                                                </Tabs>


                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </Layout>
        )
    }
}


const mapStateToProps = ({mdata}) => mdata;

const mapDispatchToProps = dispatch => ({
    valorNOK: () => dispatch(mdata_collections()),
    valor: () => dispatch(mdata_collections()),
    quantidadeNOK: () => dispatch(mdata_collections()),
    fetchData: () => dispatch(mdata_collections()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MasterData);
